//判断访问终端
var browser = {
  versions: function () {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq", //是否QQ
      ios9: app.indexOf('OS 9_') > -1, //是否是IOS9
      ios10: app.indexOf('OS 10_') > -1 //是否是IOS10
    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
/*调用原生的公用方法
 */
var callBack = function callBack() {
  if (browser.versions.android) {
    window.adFunction.dismiss();
  } else if (browser.versions.ios) {
    window.location.href = "objc:||dismiss";
  }
}
/*调用原生分享功能*/
var callShare = function callShare(share_title, share_date, share_place, share_img) {
  var iosArr = [share_title, , share_date, , share_place, , share_img];
  if (browser.versions.android) {
    window.adFunction.rightshare(share_title, share_date, share_place, share_img);
  } else if (browser.versions.ios) {
    window.location.href = "objc:||rightshare:|" + iosArr;
  }
}
/*调用原生登录方法 跳到原生登录页面*/
var callLogin = function callLogin(obj) {
  if (browser.versions.android) {
    window.adFunction.login();
  } else if (browser.versions.ios) {
    window.location.href = "objc:||login";
  }
}
/* 调用原生方法 重启一个webview*/
var callChildPage = function callChildPage(htmlName) {
  if (browser.versions.android) {
    window.adFunction.reachNextWeb(htmlName);
  } else if (browser.versions.ios) {
    window.location.href = "objc:||reachNextWeb:|" + htmlName;
  }
}
/*调用原生方法*/
var callWebFlag = function callWebFlag(flag, titleMsg) {//0  返回上一个页面  1  关闭webiview 2 关闭页面 刷新上一级页面
  if (browser.versions.android) {
    window.adFunction.setWebFlag(flag);
  } else if (browser.versions.ios) {
    var iosArr = [flag, , titleMsg];
    window.location.href = "objc:||setWebFlag:|" + iosArr;
  }
}
/*调用原生方法  设置页面title*/
var callSetTitle = function callSetTitle(titleMsg) {
  if (browser.versions.android) {
    //window.adFunction.setAndTitle(titleMsg);
  } else if (browser.versions.ios) {
    window.location.href = "objc:||setTitle:|" + titleMsg;
  }
}
exports.browser = browser;
exports.callLogin = callLogin;
exports.callShare = callShare;
exports.callBack = callBack;
exports.callChildPage = callChildPage;
exports.callWebFlag = callWebFlag;
exports.callSetTitle = callSetTitle;





// WEBPACK FOOTER //
// ./src/plugin/extendFn/native.js